import router from './router'
import store from './store'
import i18n from './i18n'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import ElementLocale from 'element-ui/lib/locale'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login'] // 无需重定向的白名单

// 初始化语言设置
const initLanguage = async () => {
  const language = localStorage.getItem('language') || 'zh-CN'
  await store.dispatch('app/setLanguage', language)
}

router.beforeEach(async(to, from, next) => {
  NProgress.start()

  // 确保语言设置已初始化
  await initLanguage()

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      try {
        // 确保获取用户信息
        if (!store.getters.roles || store.getters.roles.length === 0) {
          await store.dispatch('user/getInfo')
        }
        next()
      } catch (error) {
        await store.dispatch('user/resetToken')
        next('/login')
        NProgress.done()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach((to) => {
  NProgress.done()
  
  // 动态设置页面标题
  const setPageTitle = () => {
    const defaultTitle = i18n.t('login.title') // 使用多语言的默认标题
    const routeTitleKey = to.meta && to.meta.title ? to.meta.title : ''
    
    if (routeTitleKey) {
      // 如果是i18n的key，则翻译；否则直接使用
      const routeTitle = routeTitleKey.includes('.') ? i18n.t(routeTitleKey) : routeTitleKey
      document.title = `${routeTitle} - ${defaultTitle}`
    } else {
      document.title = defaultTitle
    }
  }
  
  // 确保i18n已经初始化后再设置标题
  if (i18n.locale) {
    setPageTitle()
  } else {
    // 如果i18n还未初始化，等待一下再设置
    setTimeout(setPageTitle, 100)
  }
})
